import { black, white, gray, blue, green, orange, purple, red, yellow } from 'primer-colors';
import { fontSizes, lineHeights } from 'primer-typography';
import React from 'react';
import { style, themeGet, color } from 'styled-system';
import system from 'system-components/emotion';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import classnames from 'classnames';
import { injectGlobal } from 'emotion';
import Octicon, { TriangleDown, GitMerge, GitPullRequest, IssueClosed, IssueOpened } from '@githubprimer/octicons-react';
import { arc, pie } from 'd3-shape';
var colors = {
  bodytext: gray[9],
  black: black,
  white: white,
  gray: gray,
  blue: blue,
  green: green,
  orange: orange,
  purple: purple,
  red: red,
  yellow: yellow,
  blackfade15: 'rgba(27, 31, 35, 0.15)',
  blackfade20: 'rgba(27, 31, 35, 0.20)',
  whitefade15: 'rgba(255, 255, 255, 0.15)',
  state: {
    error: red[5],
    failure: red[5],
    pending: yellow[7],
    queued: yellow[7],
    success: green[5],
    unknown: gray[4]
  }
};
var theme = {
  breakpoints: ['544px', '768px', '1012px', '1280px'],
  maxWidths: {
    small: '544px',
    medium: '768px',
    large: '1012px',
    xlarge: '1280px'
  },
  fonts: {
    normal: fontStack(['-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol']),
    mono: fontStack(['SFMono-Regular', 'Consolas', 'Liberation Mono', 'Menlo', 'Courier', 'monospace'])
  },
  fontWeights: {
    light: 300,
    normal: 400,
    bold: 600
  },
  colors: colors,
  borders: [0, '1px solid'],
  fontSizes: fontSizes,
  lineHeights: lineHeights,
  radii: [0, 3, 6],
  shadows: {
    small: '0 1px 1px rgba(27, 31, 35, 0.1)',
    medium: '0 1px 5px rgba(27, 31, 35, 0.15)',
    large: '0 1px 15px rgba(27, 31, 35, 0.15)',
    'extra-large': '0 10px 50px rgba(27, 31, 35, 0.07)'
  },
  space: [0, 4, 8, 16, 24, 32, 40, 48, 64, 80, 96, 112, 128]
};

function fontStack(fonts) {
  return fonts.map(function (font) {
    return font.includes(' ') ? "\"".concat(font, "\"") : font;
  }).join(', ');
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var COMMON = ['color', 'space'];
var TYPOGRAPHY = [// typography props
'fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'textAlign'];
var LAYOUT = [// layout props
'display', 'size', 'width', 'height', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight', 'overflow', 'verticalAlign'];
var POSITION = [// position props
'position', 'zIndex', 'top', 'right', 'bottom', 'left'];
var FLEX_CONTAINER = [// flex container props (display: flex)
'flexBasis', 'flexDirection', 'flexWrap', 'alignContent', 'alignItems', 'justifyContent', 'justifyItems', 'order'];
var FLEX_ITEM = [// flex container child props
'flex', 'justifySelf', 'alignSelf'];
/**
 * Defensively determine whether a component function or class is a "system
 * component" by checking its `systemComponent` flag or whether its
 * `defaultProps.blacklist` is an array.
 */

function isSystemComponent(Component) {
  return Component.systemComponent === true || Component.defaultProps && Array.isArray(Component.defaultProps.blacklist);
}
/**
 * Create a "system component" with the named props from styled-system.
 * The Component (first) argument can either be a React component (a function
 * or a class) or an object representing default props. To pass a custom
 * component with other default props, set the object's `is` key to the
 * component:
 *
 * ```js
 * const Wrapped = withSystemProps({is: Component, m: 2})
 * ```
 *
 * which is the equivalent of:
 *
 * ```js
 * const Wrapped = withSystemProps(Component)
 * Wrapped.defaultProps = {
 *   m: 2
 * }
 * ```
 */


function withSystemProps(Component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : COMMON;

  if (isSystemComponent(Component)) {
    throw new Error("".concat(Component.name, " is already a system component; can't call withSystemProps() on it"));
  }

  var component = _typeof(Component) === 'object' ? Component : {
    is: Component
  };

  if (typeof component.is === 'function') {
    component.is = guardDoubleRender(component.is);
  }

  var Wrapped = system.apply(void 0, [component].concat(_toConsumableArray(props)));
  Wrapped.displayName = Component.displayName;
  Object.assign(Wrapped.propTypes, Component.propTypes); // Set what system props we use on this component

  Wrapped.systemProps = props;
  Wrapped.systemComponent = true; // Copy over non-system keys from components
  // eg. Tooltip.js => Tooltip.directions Tooltip.alignments

  var _arr = Object.keys(Component);

  for (var _i = 0; _i < _arr.length; _i++) {
    var key = _arr[_i];

    if (!Wrapped.hasOwnProperty(key)) {
      Wrapped[key] = Component[key];
    }
  }

  return withDefaultTheme(Wrapped);
}
/**
 * Set the component's defaultProps.theme to our theme, and returns the
 * component.
 */


function withDefaultTheme(Component) {
  var theme$$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : theme;

  if (Component.defaultProps) {
    Component.defaultProps.theme = theme$$1;
  } else {
    Component.defaultProps = {
      theme: theme$$1
    };
  }

  return Component;
}
/**
 * Remove the named keys from a component's propTypes object (if present), and
 * return the component.
 */


function withoutPropTypes(Component, props) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var prop = _step.value;
      delete Component.propTypes[prop];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return Component;
}

var listStyle = style({
  prop: 'listStyle',
  cssProperty: 'list-style',
  key: 'listStyles'
});

function guardDoubleRender(Component) {
  function render(props) {
    var is = props.is,
        rest = _objectWithoutProperties(props, ["is"]);

    if (is === Component || is === render) {
      return React.createElement(Component, rest);
    } else {
      return React.createElement(Component, props);
    }
  }

  return render;
}

var BaseStyles = withSystemProps({
  is: 'div',
  color: 'gray.9',
  fontFamily: 'normal',
  lineHeight: 'default'
}, _toConsumableArray(TYPOGRAPHY).concat(_toConsumableArray(COMMON)));
var Box = withSystemProps('div', _toConsumableArray(LAYOUT).concat(_toConsumableArray(COMMON)));
var BorderBox = withSystemProps({
  is: Box,
  border: 1,
  borderColor: 'gray.2',
  borderRadius: 1
}, ['boxShadow']);
BorderBox.propTypes = _objectSpread({}, Box.propTypes);
var Flex = withSystemProps({
  is: 'div',
  display: 'flex'
}, _toConsumableArray(FLEX_CONTAINER).concat(_toConsumableArray(COMMON)));
Flex.Item = withSystemProps('div', _toConsumableArray(FLEX_ITEM).concat(_toConsumableArray(COMMON)));
var Position = withSystemProps('div', _toConsumableArray(LAYOUT).concat(_toConsumableArray(COMMON), _toConsumableArray(POSITION)));

function withPosition(position) {
  var WithPosition = function WithPosition(props) {
    return React.createElement(Position, _extends({}, props, {
      position: position
    }));
  };

  WithPosition.displayName = "Position.".concat(position);
  return WithPosition;
}

var Absolute = withPosition('absolute');
var Fixed = withPosition('fixed');
var Relative = withPosition('relative');
var Sticky = withPosition('sticky');
Sticky.defaultProps = {
  top: 0,
  zIndex: 1
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  overflow: hidden; // Ensure page layout in Firefox should images fail to load\n  line-height: ", ";\n  vertical-align: middle;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Avatar = styled(AvatarImage)(_templateObject(), themeGet('lineHeights.condensedUltra', 1), borderRadius);

function borderRadius(_ref) {
  var size = _ref.size;
  return {
    borderRadius: size <= 24 ? '2px' : '3px'
  };
}

function AvatarImage(_ref2) {
  var alt = _ref2.alt,
      size = _ref2.size,
      rest = _objectWithoutProperties(_ref2, ["alt", "size"]);

  return React.createElement("img", _extends({
    alt: alt,
    width: size,
    height: size
  }, rest));
}

AvatarImage.displayName = "AvatarImage"; // styled() changes this

Avatar.displayName = 'Avatar';
Avatar.defaultProps = {
  size: 20,
  alt: ''
};
Avatar.propTypes = {
  alt: PropTypes.string.isRequired,
  size: PropTypes.number,
  src: PropTypes.string
};
var Avatar$1 = withSystemProps(Avatar, ['space']);

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  position: relative;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var getBackgroundColor = themeGet('colors.white', '#fff');
var Wrapper = styled('div')(_templateObject$1());

var childStyles = function childStyles(props) {
  return {
    display: 'inline-block',
    overflow: 'hidden',
    // Ensure page layout in Firefox should images fail to load
    lineHeight: "".concat(themeGet('lineHeights.condensedUltra', 1)),
    verticalAlign: 'middle',
    borderRadius: '2px',
    position: 'absolute',
    right: '-15%',
    bottom: '-9%',
    boxShadow: '-2px -2px 0 rgba(255,255,255,0.8)',
    backgroundColor: "".concat(getBackgroundColor(props))
  };
};

var ChildAvatar = styled(Avatar$1)(_templateObject2(), childStyles);

var AvatarPair = function AvatarPair(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  var avatars = React.Children.map(children, function (child, i) {
    return i === 0 ? React.cloneElement(child, {
      size: 40
    }) : React.createElement(ChildAvatar, _extends({}, child.props, {
      size: 20
    }));
  });
  return React.createElement(Wrapper, rest, avatars);
};

AvatarPair.displayName = "AvatarPair"; // styled() changes this

AvatarPair.displayName = 'AvatarPair';
var AvatarPair$1 = withSystemProps(AvatarPair);
injectGlobal(".branch-name{display:inline-block;padding:2px 6px;font:12px \"SFMono-Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace;color:rgba(27,31,35,0.6);background-color:#eaf5ff;border-radius:3px}.branch-name .octicon{margin:1px -2px 0 0;color:#a8bbd0}a.branch-name{color:#0366d6}\n");

function BranchName(_ref) {
  var children = _ref.children,
      href = _ref.href,
      Tag = _ref.is,
      className = _ref.className; // We don't want someone to use href on a non tag

  if (Tag !== 'a') {
    href = null;
  }

  return React.createElement(Tag, {
    href: href,
    className: classnames('branch-name', className)
  }, children);
}

BranchName.displayName = "BranchName";
BranchName.defaultProps = {
  is: 'a'
};
var BranchName$1 = withSystemProps(BranchName, COMMON);
injectGlobal(".btn{position:relative;display:inline-block;padding:6px 12px;font-size:14px;font-weight:600;line-height:20px;white-space:nowrap;vertical-align:middle;cursor:pointer;user-select:none;background-repeat:repeat-x;background-position:-1px -1px;background-size:110% 110%;border:1px solid rgba(27,31,35,0.2);border-radius:0.25em;appearance:none}.btn i{font-style:normal;font-weight:500;opacity:0.75}.btn .octicon{vertical-align:text-top}.btn .Counter{color:#586069;text-shadow:none;background-color:rgba(27,31,35,0.1)}.btn:hover{text-decoration:none;background-repeat:repeat-x}.btn:focus{outline:0}.btn:disabled,.btn.disabled{cursor:default;background-position:0 0}.btn:active,.btn.selected{background-image:none}.btn{color:#24292e;background-color:#eff3f6;background-image:linear-gradient(-180deg, #fafbfc 0%, #eff3f6 90%)}.btn:focus,.btn.focus{box-shadow:0 0 0 0.2em rgba(3,102,214,0.3)}.btn:hover,.btn.hover{background-color:#e6ebf1;background-image:linear-gradient(-180deg, #f0f3f6 0%, #e6ebf1 90%);background-position:-.5em;border-color:rgba(27,31,35,0.35)}.btn:active,.btn.selected,[open]>.btn{background-color:#e9ecef;background-image:none;border-color:rgba(27,31,35,0.35);box-shadow:inset 0 0.15em 0.3em rgba(27,31,35,0.15)}.btn:disabled,.btn.disabled{color:rgba(36,41,46,0.4);background-color:#eff3f6;background-image:none;border-color:rgba(27,31,35,0.2);box-shadow:none}.btn-primary{color:#fff;background-color:#28a745;background-image:linear-gradient(-180deg, #34d058 0%, #28a745 90%)}.btn-primary:focus,.btn-primary.focus{box-shadow:0 0 0 0.2em rgba(52,208,88,0.4)}.btn-primary:hover,.btn-primary.hover{background-color:#269f42;background-image:linear-gradient(-180deg, #2fcb53 0%, #269f42 90%);background-position:-.5em;border-color:rgba(27,31,35,0.5)}.btn-primary:active,.btn-primary.selected,[open]>.btn-primary{background-color:#279f43;background-image:none;border-color:rgba(27,31,35,0.5);box-shadow:inset 0 0.15em 0.3em rgba(27,31,35,0.15)}.btn-primary:disabled,.btn-primary.disabled{color:rgba(255,255,255,0.75);background-color:#94d3a2;background-image:none;border-color:rgba(27,31,35,0.2);box-shadow:none}.btn-primary .Counter{color:#29b249;background-color:#fff}.btn-purple{color:#fff;background-color:#643ab0;background-image:linear-gradient(-180deg, #7e55c7 0%, #643ab0 90%)}.btn-purple:focus,.btn-purple.focus{box-shadow:0 0 0 0.2em rgba(126,85,199,0.4)}.btn-purple:hover,.btn-purple.hover{background-color:#5f37a8;background-image:linear-gradient(-180deg, #784ec5 0%, #5f37a8 90%);background-position:-.5em;border-color:rgba(27,31,35,0.5)}.btn-purple:active,.btn-purple.selected,[open]>.btn-purple{background-color:#613ca4;background-image:none;border-color:rgba(27,31,35,0.5);box-shadow:inset 0 0.15em 0.3em rgba(27,31,35,0.15)}.btn-purple:disabled,.btn-purple.disabled{color:rgba(255,255,255,0.75);background-color:#b19cd7;background-image:none;border-color:rgba(27,31,35,0.2);box-shadow:none}.btn-purple .Counter{color:#683cb8;background-color:#fff}.btn-blue{color:#fff;background-color:#0361cc;background-image:linear-gradient(-180deg, #0679fc 0%, #0361cc 90%)}.btn-blue:focus,.btn-blue.focus{box-shadow:0 0 0 0.2em rgba(6,121,252,0.4)}.btn-blue:hover,.btn-blue.hover{background-color:#035cc2;background-image:linear-gradient(-180deg, #0374f4 0%, #035cc2 90%);background-position:-.5em;border-color:rgba(27,31,35,0.5)}.btn-blue:active,.btn-blue.selected,[open]>.btn-blue{background-color:#045cc1;background-image:none;border-color:rgba(27,31,35,0.5);box-shadow:inset 0 0.15em 0.3em rgba(27,31,35,0.15)}.btn-blue:disabled,.btn-blue.disabled{color:rgba(255,255,255,0.75);background-color:#81b0e5;background-image:none;border-color:rgba(27,31,35,0.2);box-shadow:none}.btn-blue .Counter{color:#0366d6;background-color:#fff}.btn-danger{color:#cb2431;background-color:#fafbfc;background-image:linear-gradient(-180deg, #fafbfc 0%, #eff3f6 90%)}.btn-danger:focus{box-shadow:0 0 0 0.2em rgba(203,36,49,0.4)}.btn-danger:hover{color:#fff;background-color:#cb2431;background-image:linear-gradient(-180deg, #de4450 0%, #cb2431 90%);border-color:rgba(27,31,35,0.5)}.btn-danger:hover .Counter{color:#fff}.btn-danger:active,.btn-danger.selected,[open]>.btn-danger{color:#fff;background-color:#b5202c;background-image:none;border-color:rgba(27,31,35,0.5);box-shadow:inset 0 0.15em 0.3em rgba(27,31,35,0.15)}.btn-danger:disabled,.btn-danger.disabled{color:rgba(203,36,49,0.4);background-color:#eff3f6;background-image:none;border-color:rgba(27,31,35,0.2);box-shadow:none}.btn-outline{color:#0366d6;background-color:#fff;background-image:none}.btn-outline .Counter{background-color:rgba(27,31,35,0.07)}.btn-outline:hover,.btn-outline:active,.btn-outline.selected,[open]>.btn-outline{color:#fff;background-color:#0366d6;background-image:none;border-color:#0366d6}.btn-outline:hover .Counter,.btn-outline:active .Counter,.btn-outline.selected .Counter,[open]>.btn-outline .Counter{color:#0366d6;background-color:#fff}.btn-outline:focus{border-color:#0366d6;box-shadow:0 0 0 0.2em rgba(3,102,214,0.4)}.btn-outline:disabled,.btn-outline.disabled{color:rgba(27,31,35,0.3);background-color:#fff;border-color:rgba(27,31,35,0.15);box-shadow:none}.btn-with-count{float:left;border-top-right-radius:0;border-bottom-right-radius:0}.btn-sm{padding:3px 10px;font-size:12px;line-height:20px}.btn-large{padding:.75em 1.25em;font-size:inherit;border-radius:6px}.hidden-text-expander{display:block}.hidden-text-expander.inline{position:relative;top:-1px;display:inline-block;margin-left:5px;line-height:0}.hidden-text-expander a,.ellipsis-expander{display:inline-block;height:12px;padding:0 5px 5px;font-size:12px;font-weight:600;line-height:6px;color:#444d56;text-decoration:none;vertical-align:middle;background:#dfe2e5;border:0;border-radius:1px}.hidden-text-expander a:hover,.ellipsis-expander:hover{text-decoration:none;background-color:#c6cbd1}.hidden-text-expander a:active,.ellipsis-expander:active{color:#fff;background-color:#2188ff}.social-count{float:left;padding:3px 10px;font-size:12px;font-weight:600;line-height:20px;color:#24292e;vertical-align:middle;background-color:#fff;border:1px solid rgba(27,31,35,0.2);border-left:0;border-top-right-radius:3px;border-bottom-right-radius:3px}.social-count:hover,.social-count:active{text-decoration:none}.social-count:hover{color:#0366d6;cursor:pointer}.btn-block{display:block;width:100%;text-align:center}.btn-link{display:inline-block;padding:0;font-size:inherit;color:#0366d6;text-decoration:none;white-space:nowrap;cursor:pointer;user-select:none;background-color:transparent;border:0;appearance:none}.btn-link:hover{text-decoration:underline}.btn-link:disabled,.btn-link:disabled:hover{color:rgba(88,96,105,0.5);cursor:default}.details-reset>summary{list-style:none}.details-reset>summary::before{display:none}.details-reset>summary::-webkit-details-marker{display:none}.BtnGroup{display:inline-block;vertical-align:middle}.BtnGroup::before{display:table;content:\"\"}.BtnGroup::after{display:table;clear:both;content:\"\"}.BtnGroup+.BtnGroup,.BtnGroup+.btn{margin-left:5px}.BtnGroup-item{position:relative;float:left;border-right-width:0;border-radius:0}.BtnGroup-item:first-child{border-top-left-radius:3px;border-bottom-left-radius:3px}.BtnGroup-item:last-child{border-right-width:1px;border-top-right-radius:3px;border-bottom-right-radius:3px}.BtnGroup-item.selected,.BtnGroup-item:focus,.BtnGroup-item:active,.BtnGroup-item:hover{border-right-width:1px}.BtnGroup-item.selected+.BtnGroup-item,.BtnGroup-item.selected+.BtnGroup-parent .BtnGroup-item,.BtnGroup-item.selected+.BtnGroup-form .BtnGroup-item,.BtnGroup-item:focus+.BtnGroup-item,.BtnGroup-item:focus+.BtnGroup-parent .BtnGroup-item,.BtnGroup-item:focus+.BtnGroup-form .BtnGroup-item,.BtnGroup-item:active+.BtnGroup-item,.BtnGroup-item:active+.BtnGroup-parent .BtnGroup-item,.BtnGroup-item:active+.BtnGroup-form .BtnGroup-item,.BtnGroup-item:hover+.BtnGroup-item,.BtnGroup-item:hover+.BtnGroup-parent .BtnGroup-item,.BtnGroup-item:hover+.BtnGroup-form .BtnGroup-item{border-left-width:0}.BtnGroup-parent,.BtnGroup-form{float:left}.BtnGroup-parent:first-child .BtnGroup-item,.BtnGroup-form:first-child .BtnGroup-item{border-top-left-radius:3px;border-bottom-left-radius:3px}.BtnGroup-parent:last-child .BtnGroup-item,.BtnGroup-form:last-child .BtnGroup-item{border-right-width:1px;border-top-right-radius:3px;border-bottom-right-radius:3px}.BtnGroup-parent .BtnGroup-item,.BtnGroup-form .BtnGroup-item{border-right-width:0;border-radius:0}.BtnGroup-parent.selected .BtnGroup-item,.BtnGroup-parent:focus .BtnGroup-item,.BtnGroup-parent:active .BtnGroup-item,.BtnGroup-parent:hover .BtnGroup-item,.BtnGroup-form.selected .BtnGroup-item,.BtnGroup-form:focus .BtnGroup-item,.BtnGroup-form:active .BtnGroup-item,.BtnGroup-form:hover .BtnGroup-item{border-right-width:1px}.BtnGroup-parent.selected+.BtnGroup-item,.BtnGroup-parent.selected+.BtnGroup-parent .BtnGroup-item,.BtnGroup-parent.selected+.BtnGroup-form .BtnGroup-item,.BtnGroup-parent:focus+.BtnGroup-item,.BtnGroup-parent:focus+.BtnGroup-parent .BtnGroup-item,.BtnGroup-parent:focus+.BtnGroup-form .BtnGroup-item,.BtnGroup-parent:active+.BtnGroup-item,.BtnGroup-parent:active+.BtnGroup-parent .BtnGroup-item,.BtnGroup-parent:active+.BtnGroup-form .BtnGroup-item,.BtnGroup-parent:hover+.BtnGroup-item,.BtnGroup-parent:hover+.BtnGroup-parent .BtnGroup-item,.BtnGroup-parent:hover+.BtnGroup-form .BtnGroup-item,.BtnGroup-form.selected+.BtnGroup-item,.BtnGroup-form.selected+.BtnGroup-parent .BtnGroup-item,.BtnGroup-form.selected+.BtnGroup-form .BtnGroup-item,.BtnGroup-form:focus+.BtnGroup-item,.BtnGroup-form:focus+.BtnGroup-parent .BtnGroup-item,.BtnGroup-form:focus+.BtnGroup-form .BtnGroup-item,.BtnGroup-form:active+.BtnGroup-item,.BtnGroup-form:active+.BtnGroup-parent .BtnGroup-item,.BtnGroup-form:active+.BtnGroup-form .BtnGroup-item,.BtnGroup-form:hover+.BtnGroup-item,.BtnGroup-form:hover+.BtnGroup-parent .BtnGroup-item,.BtnGroup-form:hover+.BtnGroup-form .BtnGroup-item{border-left-width:0}\n");

function Button(_ref) {
  var Tag = _ref.is,
      children = _ref.children,
      size = _ref.size,
      grouped = _ref.grouped,
      scheme = _ref.scheme,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["is", "children", "size", "grouped", "scheme", "onClick", "disabled", "className"]);

  var classes = classnames(className, 'btn', {
    'btn-sm': size === 'sm',
    'btn-large': size === 'large',
    'BtnGroup-item': grouped
  }, scheme ? "btn-".concat(scheme) : null);
  return React.createElement(Tag, _extends({}, rest, {
    type: "button",
    disabled: disabled,
    onClick: disabled ? undefined : onClick,
    className: classes
  }), children);
}

Button.displayName = "Button";
Button.defaultProps = {
  is: 'button'
};
var Button$1 = withSystemProps(Button, _toConsumableArray(COMMON).concat(['width']));

var ButtonDanger = function ButtonDanger(props) {
  return React.createElement(Button$1, _extends({}, props, {
    scheme: "danger"
  }));
};

ButtonDanger.displayName = "ButtonDanger";

var ButtonOutline = function ButtonOutline(props) {
  return React.createElement(Button$1, _extends({}, props, {
    scheme: "outline"
  }));
};

ButtonOutline.displayName = "ButtonOutline";

var ButtonPrimary = function ButtonPrimary(props) {
  return React.createElement(Button$1, _extends({}, props, {
    scheme: "primary"
  }));
};

ButtonPrimary.displayName = "ButtonPrimary";
var oppositeEdge = {
  top: 'Bottom',
  right: 'Left',
  bottom: 'Top',
  left: 'Right'
};
var perpendicularEdge = {
  top: 'Left',
  right: 'Top',
  bottom: 'Left',
  left: 'Top'
};

function getEdgeAlign(location) {
  var _location$split = location.split('-'),
      _location$split2 = _slicedToArray(_location$split, 2),
      edge = _location$split2[0],
      align = _location$split2[1];

  return [edge, align];
}

function getPosition(edge, align, spacing) {
  var _ref;

  var opposite = oppositeEdge[edge].toLowerCase();
  var perp = perpendicularEdge[edge].toLowerCase();
  return _ref = {}, _defineProperty(_ref, opposite, '100%'), _defineProperty(_ref, align || perp, align ? spacing : '50%'), _ref;
}

var getBg = style({
  prop: 'bg',
  key: 'colors'
});
var getBorderColor = style({
  prop: 'borderColor',
  key: 'colors'
});
var getBorderWidth = style({
  prop: 'borderWidth',
  key: 'borderWidths',
  scale: [0, 1]
});
var getSize = style({
  prop: 'size',
  key: 'space'
});

function Caret(props) {
  var _getBg = getBg(props),
      bg = _getBg.bg;

  var _getBorderColor = getBorderColor(props),
      borderColor = _getBorderColor.borderColor;

  var _getBorderWidth = getBorderWidth(props),
      borderWidth = _getBorderWidth.borderWidth;

  var _getSize = getSize(props),
      size = _getSize.size;

  var location = props.location;

  var _getEdgeAlign = getEdgeAlign(location),
      _getEdgeAlign2 = _slicedToArray(_getEdgeAlign, 2),
      edge = _getEdgeAlign2[0],
      align = _getEdgeAlign2[1];

  var perp = perpendicularEdge[edge];

  var style$$1 = _objectSpread({
    pointerEvents: 'none',
    position: 'absolute'
  }, getPosition(edge, align, size), _defineProperty({}, "margin".concat(perp), align ? null : -size)); // note: these arrays represent points in the form [x, y]


  var a = [-size, 0];
  var b = [0, size];
  var c = [size, 0]; // spaces are optional in path `d` attribute, and points are
  // represented in the form `x,y` -- which is what the arrays above
  // become when stringified!

  var triangle = "M".concat(a, "L").concat(b, "L").concat(c, "L").concat(a, "Z");
  var line = "M".concat(a, "L").concat(b, "L").concat(c);
  var transform = {
    top: "translate(".concat([size, size * 2], ") rotate(180)"),
    right: "translate(".concat([0, size], ") rotate(-90)"),
    bottom: "translate(".concat([size, 0], ")"),
    left: "translate(".concat([size * 2, size], ") rotate(90)")
  }[edge];
  return React.createElement("svg", {
    width: size * 2,
    height: size * 2,
    style: style$$1
  }, React.createElement("g", {
    transform: transform
  }, React.createElement("path", {
    d: triangle,
    fill: bg
  }), React.createElement("path", {
    d: line,
    fill: "none",
    stroke: borderColor,
    strokeWidth: borderWidth
  })));
}

Caret.displayName = "Caret";
Caret.locations = ['top', 'top-left', 'top-right', 'right', 'right-top', 'right-bottom', 'bottom', 'bottom-left', 'bottom-right', 'left', 'left-top', 'left-bottom'];
Caret.defaultProps = {
  bg: 'white',
  borderColor: 'gray.2',
  borderWidth: 1,
  location: 'bottom',
  size: 2
};
var Caret$1 = withDefaultTheme(Caret);
injectGlobal(".CircleBadge{display:flex;align-items:center;justify-content:center;background-color:#fff;border-radius:50%;box-shadow:0 1px 5px rgba(27,31,35,0.15)}.CircleBadge-icon{max-width:60% !important;height:auto !important;max-height:55% !important}.CircleBadge--small{width:56px;height:56px}.CircleBadge--medium{width:96px;height:96px}.CircleBadge--large{width:128px;height:128px}.DashedConnection{position:relative}.DashedConnection::before{position:absolute;top:50%;left:0;width:100%;content:\"\";border-bottom:2px dashed #e1e4e8}.DashedConnection .CircleBadge{position:relative}\n");
var ICON_CLASS = 'CircleBadge-icon';

var sizeMapper = function sizeMapper() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medium';
  if (typeof size === 'number') return size;
  var map = {
    small: 56,
    medium: 96,
    large: 128
  };
  return map[size];
};

var sizeStyles = function sizeStyles(_ref) {
  var size = _ref.size;
  return {
    width: sizeMapper(size),
    height: sizeMapper(size)
  };
};

var CircleBadge = function CircleBadge(_ref2) {
  var _ref2$is = _ref2.is,
      Tag = _ref2$is === void 0 ? 'div' : _ref2$is,
      children = _ref2.children,
      className = _ref2.className,
      rest = _objectWithoutProperties(_ref2, ["is", "children", "className"]);

  var mappedChildren = React.Children.map(children, function (child) {
    var _child$props$classNam = child.props.className,
        className = _child$props$classNam === void 0 ? '' : _child$props$classNam;

    if (!className.includes(ICON_CLASS)) {
      className = classnames(ICON_CLASS, className);
    }

    return React.cloneElement(child, {
      className: className
    });
  });
  var classes = classnames(className, 'CircleBadge');
  return React.createElement(Tag, _extends({
    className: classes
  }, rest), mappedChildren);
};

CircleBadge.displayName = "CircleBadge";
var CircleBadge$1 = withSystemProps(CircleBadge, _toConsumableArray(COMMON).concat([sizeStyles]));

function CircleOcticon(props) {
  var size = props.size;

  var icon = props.icon,
      bg = props.bg,
      rest = _objectWithoutProperties(props, ["icon", "bg"]);

  return React.createElement(BorderBox, {
    bg: bg,
    overflow: "hidden",
    border: "none",
    size: size,
    borderRadius: "50%"
  }, React.createElement(Flex, _extends({}, rest, {
    alignItems: "center",
    justifyContent: "center"
  }), React.createElement(Octicon, {
    icon: icon,
    size: size
  })));
}

CircleOcticon.displayName = "CircleOcticon";
CircleOcticon.defaultProps = _objectSpread({}, Flex.defaultProps, {
  size: 32
});
injectGlobal(".Counter{display:inline-block;padding:2px 5px;font-size:12px;font-weight:600;line-height:1;color:#586069;background-color:rgba(27,31,35,0.08);border-radius:20px}.Counter--gray-light{color:#24292e;background-color:rgba(27,31,35,0.15)}.Counter--gray{color:#fff;background-color:#6a737d}\n");

function CounterLabel(_ref) {
  var scheme = _ref.scheme,
      children = _ref.children,
      className = _ref.className;
  return React.createElement("span", {
    className: classnames(className, 'Counter', scheme && "Counter--".concat(scheme))
  }, children);
}

CounterLabel.displayName = "CounterLabel";
var CounterLabel$1 = withSystemProps(CounterLabel, COMMON);

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  & > summary {\n    list-style: none;\n  }\n  & > summary::before {\n    display: none;\n  }\n  & > summary::-webkit-details-marker {\n    display: none;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var DetailsReset = styled('details')(_templateObject$2());

var Details =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Details, _React$Component);

  function Details(props) {
    var _this;

    _classCallCheck(this, Details);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Details).call(this, props));
    _this.state = {
      open: Boolean(props.open)
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Details, [{
    key: "toggle",
    value: function toggle(event) {
      if (event) {
        event.preventDefault();
      }

      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          _this$props$render = _this$props.render,
          render = _this$props$render === void 0 ? getRenderer(children) : _this$props$render,
          rest = _objectWithoutProperties(_this$props, ["children", "render"]);

      var open = this.state.open;
      return React.createElement(DetailsReset, _extends({}, rest, {
        open: open
      }), render({
        open: open,
        toggle: this.toggle
      }));
    }
  }]);

  return Details;
}(React.Component);

Details.displayName = "Details";

function getRenderer(children) {
  return typeof children === 'function' ? children : function () {
    return children;
  };
}

var Details$1 = withoutPropTypes(withSystemProps(Details, COMMON), ['is']);
var defaultColor = '#666';
var getStateColors = themeGet('colors.state', {});

function Donut(props) {
  var className = props.className,
      data = props.data,
      _props$children = props.children,
      children = _props$children === void 0 ? mapData(data) : _props$children,
      size = props.size;
  var radius = size / 2;
  var innerRadius = radius - 6;
  var pie$$1 = pie().value(function (child) {
    return child.props.value;
  }); // coerce the children into an array

  var childList = React.Children.toArray(children);
  var arcData = pie$$1(childList);
  var arc$$1 = arc().innerRadius(innerRadius).outerRadius(radius);
  var slices = childList.map(function (child, i) {
    return React.cloneElement(child, {
      d: arc$$1(arcData[i])
    });
  });
  return React.createElement("svg", {
    width: size,
    height: size,
    className: className
  }, React.createElement("g", {
    transform: "translate(".concat(radius, ",").concat(radius, ")")
  }, slices));
}

Donut.displayName = "Donut";

function mapData(data) {
  return Object.keys(data).map(function (key) {
    return React.createElement(Slice, {
      key: key,
      state: key,
      value: data[key]
    });
  });
}

Donut.defaultProps = {
  size: 30
};
var Slice = withDefaultTheme(function (props) {
  var children = props.children,
      d = props.d,
      fill = props.fill,
      state = props.state,
      value = props.value;
  var stateColors = getStateColors(props);
  var color$$1 = fill || stateColors[state] || stateColors.unknown || defaultColor;
  return React.createElement("path", {
    d: d,
    fill: color$$1,
    "data-value": value
  }, children);
});
Donut.Slice = Slice;
var Donut$1 = withSystemProps(Donut, ['space']);
var StyledOcticon = withSystemProps(Octicon, COMMON);

function Dropdown(_ref) {
  var title = _ref.title,
      scheme = _ref.scheme,
      children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["title", "scheme", "children", "className"]);

  var minWidth = rest.minWidth;
  return React.createElement("div", _extends({
    className: classnames(className, 'BtnGroup')
  }, rest), React.createElement(Flex, {
    is: Details$1,
    className: "BtnGroup-form",
    css: {
      position: 'relative'
    }
  }, function (_ref2) {
    var toggle = _ref2.toggle;
    return React.createElement(React.Fragment, null, React.createElement(Button$1, {
      is: "summary",
      scheme: scheme,
      grouped: true,
      onClick: toggle
    }, title, React.createElement(StyledOcticon, {
      icon: TriangleDown,
      size: 14,
      ml: title ? 2 : 0
    })), React.createElement(BorderBox, {
      bg: "white",
      border: 1,
      borderColor: "gray.2",
      borderRadius: 1,
      boxShadow: "small",
      mt: 1,
      px: 3,
      py: 2,
      minWidth: minWidth,
      css: {
        position: 'absolute',
        zIndex: 99999
      }
    }, children, React.createElement(Caret$1, {
      location: "top-left"
    })));
  }));
}

Dropdown.displayName = "Dropdown";
var Dropdown$1 = withSystemProps(Dropdown, COMMON);
injectGlobal(".filter-list{list-style-type:none}.filter-list.small .filter-item{padding:4px 10px;margin:0 0 2px;font-size:12px}.filter-list.pjax-active .filter-item{color:#586069;background-color:transparent}.filter-list.pjax-active .filter-item.pjax-active{color:#fff;background-color:#0366d6}.filter-item{position:relative;display:block;padding:8px 10px;margin-bottom:5px;overflow:hidden;font-size:14px;color:#586069;text-decoration:none;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;border-radius:3px}.filter-item:hover{text-decoration:none;background-color:#eaecef}.filter-item.selected{color:#fff;background-color:#0366d6}.filter-item .count{float:right;font-weight:600}.filter-item .bar{position:absolute;top:2px;right:0;bottom:2px;z-index:-1;display:inline-block;background-color:#eff3f6}\n");
var ITEM_CLASS = 'filter-item';
var SELECTED_CLASS = 'selected';

function FilterList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      small = _ref.small;
  var classes = classnames(className, 'filter-list', small && 'small');
  var items = React.Children.map(children, function (child) {
    return React.createElement("li", null, child);
  });
  return React.createElement("ul", {
    className: classes
  }, items);
}

FilterList.displayName = "FilterList";

function getCountComponent(count) {
  return React.createElement("span", {
    className: "count",
    title: "results"
  }, count);
}

getCountComponent.displayName = "getCountComponent";

function Item(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      count = _ref2.count,
      selected = _ref2.selected,
      Tag = _ref2.is,
      rest = _objectWithoutProperties(_ref2, ["children", "className", "count", "selected", "is"]);

  var classes = classnames(ITEM_CLASS, selected && SELECTED_CLASS, className);

  if (typeof rest.to === 'string') {
    rest.activeClassName = SELECTED_CLASS;
  }

  return React.createElement(Tag, _extends({
    className: classes
  }, rest), count && getCountComponent(count), children);
}

Item.displayName = "Item";
Item.defaultProps = {
  is: 'a'
};
FilterList.defaultProps = {
  m: 0,
  p: 0
};
FilterList.Item = withSystemProps(Item, COMMON);
var FilterList$1 = withSystemProps(FilterList, COMMON);
injectGlobal(".flash{position:relative;padding:16px;color:#032f62;background-color:#dbedff;border:1px solid rgba(27,31,35,0.15);border-radius:3px}.flash p:last-child{margin-bottom:0}.flash-messages{margin-bottom:24px}.flash-close{float:right;padding:16px;margin:-16px;color:inherit;text-align:center;cursor:pointer;background:none;border:0;appearance:none;opacity:0.6}.flash-close:hover{opacity:1}.flash-action{float:right;margin-top:-3px;margin-left:24px}.flash-warn{color:#735c0f;background-color:#fffbdd;border-color:rgba(27,31,35,0.15)}.flash-error{color:#86181d;background-color:#ffdce0;border-color:rgba(27,31,35,0.15)}.flash-success{color:#165c26;background-color:#dcffe4;border-color:rgba(27,31,35,0.15)}.flash-full{margin-top:-1px;border-width:1px 0;border-radius:0}.warning{padding:.5em;margin-bottom:0.8em;font-weight:600;background-color:#fffbdd}\n");
var schemeMap = {
  green: 'success',
  red: 'error',
  yellow: 'warn'
};

function Flash(_ref) {
  var children = _ref.children,
      className = _ref.className,
      full = _ref.full,
      scheme = _ref.scheme;
  var classes = classnames(className, 'flash', full && 'flash-full', scheme && "flash-".concat(schemeMap[scheme]));
  return React.createElement("div", {
    className: classes
  }, children);
}

Flash.displayName = "Flash";
var Flash$1 = withSystemProps(Flash, COMMON);
var Heading = withSystemProps({
  is: 'h1',
  fontSize: 5,
  m: 0
}, _toConsumableArray(TYPOGRAPHY).concat(_toConsumableArray(COMMON)));

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-weight: 600;\n  line-height: ", ";\n  color: ", ";\n  border-radius: 2px;\n  &:hover {\n    text-decoration: none;\n  }\n  ", ";\n  ", ";\n  ", ";\n  ", "; // must be last to override other values\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var sizeMap = {
  small: "padding 0.125em ".concat(theme.space[1], "px; font-size: ").concat(theme.fontSizes[0], "px;"),
  medium: "padding: 3px ".concat(theme.space[1], "px; font-size: ").concat(theme.fontSizes[0], "px;"),
  large: "padding: 4px ".concat(theme.space[2], "px; ").concat(theme.fontSizes[1], "px;"),
  xl: "padding: ".concat(theme.space[1], "px; ").concat(theme.space[2], "px; ").concat(theme.fontSizes[2], "px;")
};
var outlineStyles = "\n  margin-top: -1px; // offsets the 1px border\n  margin-bottom: -1px; // offsets the 1px border\n  font-weight: 400;\n  color: ".concat(colors.gray[6], ";\n  background-color: transparent;\n  border: ").concat(theme.borders[1], " ").concat(colors.blackfade15, ";\n  box-shadow: none;\n");
var styledLabel = styled('span')(_templateObject$3(), theme.lineHeights.condensedUltra, colors.white, color, function (props) {
  return props.dropshadow ? 'box-shadow: inset 0 -1px 0 rgba(27, 31, 35, 0.12)' : '';
}, function (props) {
  return sizeMap[props.size];
}, function (props) {
  return props.outline ? outlineStyles : '';
});
styledLabel.defaultProps = {
  theme: theme,
  bg: 'gray.5',
  size: 'medium'
};
styledLabel.propTypes = {
  dropshadow: PropTypes.bool,
  outline: PropTypes.bool
};
var Label = withSystemProps(styledLabel, COMMON);

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: ", ";\n  &:hover {\n    text-decoration: underline;\n    ", ";\n  }\n  ", ";\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var buttonStyles = {
  display: 'inline-block',
  padding: '0',
  fontSize: 'inherit',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  userSelect: 'none',
  backgroundColor: 'transparent',
  border: '0',
  appearance: 'none'
};
var hoverColor = style({
  prop: 'hoverColor',
  cssProperty: 'color',
  key: 'colors'
});

var Link = function Link(_ref) {
  var Tag = _ref.is,
      rest = _objectWithoutProperties(_ref, ["is"]);

  return React.createElement(Tag, rest);
};

Link.displayName = "Link";
var styledLink = styled(Link)(_templateObject$4(), function (props) {
  return props.underline ? 'underline' : 'none';
}, hoverColor, function (props) {
  return props.is === 'button' ? buttonStyles : '';
});
styledLink.defaultProps = {
  is: 'a',
  theme: theme
};
styledLink.propTypes = {
  href: PropTypes.string,
  is: PropTypes.oneOf(['a', 'button', 'input', 'summary']),
  underline: PropTypes.bool
};
var Link$1 = withSystemProps({
  is: styledLink,
  color: 'blue.5'
}, _toConsumableArray(TYPOGRAPHY).concat(_toConsumableArray(COMMON)));

function OcticonButton(_ref) {
  var disabled = _ref.disabled,
      className = _ref.className,
      icon = _ref.icon,
      label = _ref.label,
      onClick = _ref.onClick,
      size = _ref.size;
  var buttonProps = {
    'aria-label': label,
    className: classnames('btn-link text-inherit', className),
    disabled: disabled,
    onClick: onClick
  };
  var octiconProps = {
    icon: icon,
    size: size
  };
  return React.createElement("button", buttonProps, React.createElement(Octicon, octiconProps));
}

OcticonButton.displayName = "OcticonButton";
OcticonButton.defaultProps = {
  label: ''
};
var OcticonButton$1 = withSystemProps(OcticonButton, COMMON);

function PointerBox(props) {
  // don't destructure these, just grab them
  var bg = props.bg,
      border = props.border,
      borderColor = props.borderColor;

  var caret = props.caret,
      children = props.children,
      boxProps = _objectWithoutProperties(props, ["caret", "children"]);

  var caretProps = {
    bg: bg,
    borderColor: borderColor,
    borderWidth: border,
    location: caret
  };
  return React.createElement(BorderBox, _extends({}, boxProps, {
    css: {
      position: 'relative'
    }
  }), children, React.createElement(Caret$1, caretProps));
}

PointerBox.displayName = "PointerBox";
PointerBox.systemComponent = true;

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  padding: ", ";\n  font-weight: 600;\n  line-height: 20px;\n  color: ", ";\n  font-size: ", ";\n  text-align: center;\n  background-color: ", ";\n  border-radius: ", "px;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var statusMap = {
  issueClosed: colors.red[6],
  pullClosed: colors.red[6],
  pullMerged: colors.purple[5],
  issueOpened: '#2cbe4e',
  // This was generated by a sass function in Primer, so using a hex here
  pullOpened: '#2cbe4e',
  // This was generated by a sass function in Primer, so using a hex here
  gray: colors.gray[5]
};
var octiconMap = {
  issueOpened: IssueOpened,
  pullOpened: GitPullRequest,
  issueClosed: IssueClosed,
  pullClosed: GitPullRequest,
  pullMerged: GitMerge
};

function StateLabel(_ref) {
  var className = _ref.className,
      status = _ref.status,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      children = _ref.children;
  var octiconProps = small ? {
    width: '1em'
  } : {};
  return React.createElement("span", {
    className: className
  }, status && React.createElement(StyledOcticon, _extends({
    mr: 1
  }, octiconProps, {
    icon: octiconMap[status]
  })), children);
}

StateLabel.displayName = "StateLabel";
var styledLabel$1 = styled(StateLabel)(_templateObject$5(), function (props) {
  return props.small ? "0.125em ".concat(theme.space[1], "px") : "".concat(theme.space[1], "px ").concat(theme.space[2], "px");
}, colors.white, function (props) {
  return props.small ? "".concat(theme.fontSizes[0], "px") : "".concat(theme.fontSizes[1], "px");
}, function (props) {
  return props.status ? statusMap[props.status] : statusMap.gray;
}, theme.radii[1]);
var StateLabel$1 = withSystemProps(styledLabel$1, COMMON);
injectGlobal("fieldset{padding:0;margin:0;border:0}label{font-weight:600}.form-control,.form-select{min-height:34px;padding:6px 8px;font-size:16px;line-height:20px;color:#24292e;vertical-align:middle;background-color:#fff;background-repeat:no-repeat;background-position:right 8px center;border:1px solid #d1d5da;border-radius:3px;outline:none;box-shadow:inset 0 1px 2px rgba(27,31,35,0.075)}.form-control.focus,.form-control:focus,.form-select.focus,.form-select:focus{border-color:#2188ff;outline:none;box-shadow:inset 0 1px 2px rgba(27,31,35,0.075),0 0 0 0.2em rgba(3,102,214,0.3)}@media (min-width: 768px){.form-control,.form-select{font-size:14px}}.input-contrast{background-color:#fafbfc}.input-contrast:focus{background-color:#fff}::placeholder{color:#6a737d}.input-sm{min-height:28px;padding-top:3px;padding-bottom:3px;font-size:12px;line-height:20px}.input-lg{padding:4px 10px;font-size:16px}.input-block{display:block;width:100%}.input-monospace{font-family:\"SFMono-Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace}.input-hide-webkit-autofill::-webkit-contacts-auto-fill-button{position:absolute;right:0;display:none !important;pointer-events:none;visibility:hidden}.form-checkbox{padding-left:20px;margin:15px 0;vertical-align:middle}.form-checkbox label em.highlight{position:relative;left:-4px;padding:2px 4px;font-style:normal;background:#fffbdd;border-radius:3px}.form-checkbox input[type=checkbox],.form-checkbox input[type=radio]{float:left;margin:5px 0 0 -20px;vertical-align:middle}.form-checkbox .note{display:block;margin:0;font-size:12px;font-weight:400;color:#586069}.form-checkbox-details{display:none}.form-checkbox-details-trigger:checked ~ * .form-checkbox-details,.form-checkbox-details-trigger:checked ~ .form-checkbox-details{display:block}.hfields{margin:15px 0}.hfields::before{display:table;content:\"\"}.hfields::after{display:table;clear:both;content:\"\"}.hfields .form-group{float:left;margin:0 30px 0 0}.hfields .form-group dt label{display:inline-block;margin:5px 0 0;color:#586069}.hfields .form-group dt img{position:relative;top:-2px}.hfields .btn{float:left;margin:28px 25px 0 -20px}.hfields .form-select{margin-top:5px}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{margin:0;appearance:none}.form-actions::before{display:table;content:\"\"}.form-actions::after{display:table;clear:both;content:\"\"}.form-actions .btn{float:right}.form-actions .btn+.btn{margin-right:5px}.form-warning{padding:8px 10px;margin:10px 0;font-size:14px;color:#735c0f;background:#fffbdd;border:1px solid #d9d0a5;border-radius:3px}.form-warning p{margin:0;line-height:1.5}.form-warning a{font-weight:600}\n");

function TextInput(_ref) {
  var autocomplete = _ref.autocomplete,
      block = _ref.block,
      className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["autocomplete", "block", "className", "size"]);

  var classes = classnames(className, 'form-control', {
    'input-block': block,
    'input-sm': size === 'small',
    'input-lg': size === 'large'
  });

  var inputProps = _objectSpread({
    className: classes,
    autoComplete: autocomplete,
    type: 'text'
  }, rest);

  return React.createElement("input", inputProps);
}

TextInput.displayName = "TextInput";
var TextInput$1 = withSystemProps(TextInput, COMMON);
var Text = withSystemProps('span', _toConsumableArray(TYPOGRAPHY).concat(_toConsumableArray(COMMON)));
injectGlobal(".tooltipped{position:relative}.tooltipped::after{position:absolute;z-index:1000000;display:none;padding:.5em .75em;font:normal normal 11px/1.5 -apple-system,BlinkMacSystemFont,\"Segoe UI\",Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";-webkit-font-smoothing:subpixel-antialiased;color:#fff;text-align:center;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-wrap:break-word;white-space:pre;pointer-events:none;content:attr(aria-label);background:#1b1f23;border-radius:3px;opacity:0}.tooltipped::before{position:absolute;z-index:1000001;display:none;width:0;height:0;color:#1b1f23;pointer-events:none;content:\"\";border:6px solid transparent;opacity:0}@keyframes tooltip-appear{from{opacity:0}to{opacity:1}}.tooltipped:hover::before,.tooltipped:hover::after,.tooltipped:active::before,.tooltipped:active::after,.tooltipped:focus::before,.tooltipped:focus::after{display:inline-block;text-decoration:none;animation-name:tooltip-appear;animation-duration:.1s;animation-fill-mode:forwards;animation-timing-function:ease-in;animation-delay:.4s}.tooltipped-no-delay:hover::before,.tooltipped-no-delay:hover::after,.tooltipped-no-delay:active::before,.tooltipped-no-delay:active::after,.tooltipped-no-delay:focus::before,.tooltipped-no-delay:focus::after{animation-delay:0s}.tooltipped-multiline:hover::after,.tooltipped-multiline:active::after,.tooltipped-multiline:focus::after{display:table-cell}.tooltipped-s::after,.tooltipped-se::after,.tooltipped-sw::after{top:100%;right:50%;margin-top:6px}.tooltipped-s::before,.tooltipped-se::before,.tooltipped-sw::before{top:auto;right:50%;bottom:-7px;margin-right:-6px;border-bottom-color:#1b1f23}.tooltipped-se::after{right:auto;left:50%;margin-left:-16px}.tooltipped-sw::after{margin-right:-16px}.tooltipped-n::after,.tooltipped-ne::after,.tooltipped-nw::after{right:50%;bottom:100%;margin-bottom:6px}.tooltipped-n::before,.tooltipped-ne::before,.tooltipped-nw::before{top:-7px;right:50%;bottom:auto;margin-right:-6px;border-top-color:#1b1f23}.tooltipped-ne::after{right:auto;left:50%;margin-left:-16px}.tooltipped-nw::after{margin-right:-16px}.tooltipped-s::after,.tooltipped-n::after{transform:translateX(50%)}.tooltipped-w::after{right:100%;bottom:50%;margin-right:6px;transform:translateY(50%)}.tooltipped-w::before{top:50%;bottom:50%;left:-7px;margin-top:-6px;border-left-color:#1b1f23}.tooltipped-e::after{bottom:50%;left:100%;margin-left:6px;transform:translateY(50%)}.tooltipped-e::before{top:50%;right:-7px;bottom:50%;margin-top:-6px;border-right-color:#1b1f23}.tooltipped-align-right-1::after,.tooltipped-align-right-2::after{right:0;margin-right:0}.tooltipped-align-right-1::before{right:10px}.tooltipped-align-right-2::before{right:15px}.tooltipped-align-left-1::after,.tooltipped-align-left-2::after{left:0;margin-left:0}.tooltipped-align-left-1::before{left:5px}.tooltipped-align-left-2::before{left:10px}.tooltipped-multiline::after{width:max-content;max-width:250px;word-wrap:break-word;white-space:pre-line;border-collapse:separate}.tooltipped-multiline.tooltipped-s::after,.tooltipped-multiline.tooltipped-n::after{right:auto;left:50%;transform:translateX(-50%)}.tooltipped-multiline.tooltipped-w::after,.tooltipped-multiline.tooltipped-e::after{right:100%}@media screen and (min-width: 0\\0){.tooltipped-multiline::after{width:250px}}.tooltipped-sticky::before,.tooltipped-sticky::after{display:inline-block}.tooltipped-sticky.tooltipped-multiline::after{display:table-cell}\n");

function Tooltip(_ref) {
  var direction = _ref.direction,
      children = _ref.children,
      className = _ref.className,
      text = _ref.text,
      noDelay = _ref.noDelay,
      align = _ref.align,
      wrap = _ref.wrap;
  var classes = classnames(className, 'tooltipped', "tooltipped-".concat(direction), align && "tooltipped-align-".concat(align, "-2"), noDelay && 'tooltipped-no-delay', wrap && 'tooltipped-multiline');
  return React.createElement("span", {
    "aria-label": text,
    className: classes
  }, children);
}

Tooltip.displayName = "Tooltip";
Tooltip.alignments = ['left', 'right'];
Tooltip.directions = ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw'];
Tooltip.defaultProps = {
  direction: 'n'
};
var Tooltip$1 = withSystemProps(Tooltip, COMMON);
injectGlobal(".UnderlineNav{display:flex;justify-content:space-between;border-bottom:1px solid #e1e4e8}.UnderlineNav-body{display:flex;margin-bottom:-1px}.UnderlineNav-item{padding:16px 8px;margin-right:16px;font-size:14px;line-height:1.5;color:#586069;text-align:center;border-bottom:2px solid transparent}.UnderlineNav-item:hover,.UnderlineNav-item:focus{color:#24292e;text-decoration:none;border-bottom-color:#d1d5da;transition:0.2s ease}.UnderlineNav-item:hover .UnderlineNav-octicon,.UnderlineNav-item:focus .UnderlineNav-octicon{color:#6a737d}.UnderlineNav-item.selected{font-weight:600;color:#24292e;border-bottom-color:#e36209}.UnderlineNav-item.selected .UnderlineNav-octicon{color:#6a737d}.UnderlineNav--right{justify-content:flex-end}.UnderlineNav--right .UnderlineNav-item{margin-right:0;margin-left:16px}.UnderlineNav--right .UnderlineNav-actions{flex:1 1 auto}.UnderlineNav-actions{align-self:center}.UnderlineNav--full{display:block}.UnderlineNav-octicon{color:#959da5}.UnderlineNav-container{display:flex;justify-content:space-between}\n");
var ITEM_CLASS$1 = 'UnderlineNav-item no-underline';
var SELECTED_CLASS$1 = 'selected';

function UnderlineNav(_ref) {
  var actions = _ref.actions,
      className = _ref.className,
      align = _ref.align,
      children = _ref.children,
      full = _ref.full,
      label = _ref.label;
  var classes = classnames(className, 'UnderlineNav', align && "UnderlineNav--".concat(align), full && 'UnderlineNav--full');
  return React.createElement("nav", {
    className: classes,
    "aria-label": label
  }, React.createElement("div", {
    className: "UnderlineNav-body"
  }, children), actions && React.createElement("div", {
    className: "UnderlineNav-actions"
  }, actions));
}

UnderlineNav.displayName = "UnderlineNav";

var UnderlineNavLink = function UnderlineNavLink(_ref2) {
  var className = _ref2.className,
      selected = _ref2.selected,
      Tag = _ref2.is,
      rest = _objectWithoutProperties(_ref2, ["className", "selected", "is"]);

  var classes = classnames(ITEM_CLASS$1, selected && SELECTED_CLASS$1, className);

  if (typeof rest.to === 'string') {
    rest.activeClassName = SELECTED_CLASS$1;
  }

  return React.createElement(Tag, _extends({
    className: classes
  }, rest));
};

UnderlineNavLink.displayName = "UnderlineNavLink";
UnderlineNavLink.defaultProps = {
  is: 'a'
};
UnderlineNav.Link = withSystemProps(UnderlineNavLink, COMMON);
var UnderlineNav$1 = withSystemProps(UnderlineNav, COMMON);
injectGlobal("*{box-sizing:border-box}body{margin:0}table{border-collapse:collapse}\n");
export { theme, BaseStyles, BorderBox, Box, Flex, Position, Absolute, Fixed, Relative, Sticky, Avatar$1 as Avatar, AvatarPair$1 as AvatarPair, BranchName$1 as BranchName, ButtonDanger, ButtonOutline, ButtonPrimary, Button$1 as Button, Caret$1 as Caret, CircleBadge$1 as CircleBadge, CircleOcticon, CounterLabel$1 as CounterLabel, Details$1 as Details, Donut$1 as Donut, Dropdown$1 as Dropdown, FilterList$1 as FilterList, Flash$1 as Flash, Heading, Label, Link$1 as Link, OcticonButton$1 as OcticonButton, PointerBox, StateLabel$1 as StateLabel, StyledOcticon, TextInput$1 as TextInput, Text, Tooltip$1 as Tooltip, UnderlineNav$1 as UnderlineNav };